import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Permission } from "../models/permission.model";
import { AuthenticationService } from "../services/authentication.service";

@Injectable()
export class IsAdminGuard  {
  constructor(private authService: AuthenticationService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAdmin = (await this.authService.getLatestRolesAndPermissionsAsync()).hasPermission(Permission.AdminPages);
    if(!isAdmin) this.router.navigate(['/no-access-to-feature'])
    return isAdmin;
  }
}